import Node from 'nanogl-node'

export class PlayerEntity {
  visualLane: number = 0
  lane: number = 0
  direction: number = 0
  node: Node = new Node()
  locked: boolean = false
  grabDisabled: boolean = false
}
